export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_TEKAY_complete_6.9c55192a.jpg";